<template>
  <div>
    <button @click="videoVisible = true">
      查看视频
    </button>
    <VideoDrawer
      :title="lessonName"
      :visible.sync="videoVisible"
      :ai-lesson-id="aiLessonId"
      :lesson-id="lessonId"
      :class-type-id="classTypeId"
    />
  </div>
</template>
<script>
import VideoDrawer from '@/components/VideoPlayer/VideoDrawer.vue'
export default {
  components: {
    VideoDrawer
  },
  data() {
    return {
      videoVisible: false,
      // ai讲次id
      aiLessonId: 5704,
      lessonId: 1127530921,
      // 班型id
      classTypeId: 136682,
      lessonName: '这里是讲次名称哈哈哈'
    }
  }
}
</script>